<template>
  <div class="vg_wrapper">
    <div class="vd_edhea">
      <editHeader
        :isShow="isShow"
        :btn="btn"
        :strForm="crftForm"
        @openEdit="openEdit"
        @closeEdit="closeEdit"
        @submit="submit('crftForm')"/>
      <el-button type="primary" size="small" class="vd_export" @click="buttonRefresh()" v-if="isShow">刷新</el-button>
    </div>
    <el-form ref="crftForm" :model="crftForm" :rules="rules" :disabled="isShow" label-width="120px" size="mini">
      <el-row :gutter="24">
        <el-col :md="8">
          <el-form-item label="工艺编号" prop="crft_no">
            <el-input v-model="crftForm.crft_no" maxlength="10" @input ="crftForm.crft_no = helper.keepEngNum2(crftForm.crft_no)" show-word-limit placeholder="请填写工艺编号（仅支持数字和英文）"></el-input>
          </el-form-item>
        </el-col>
        <el-col :md="8">
          <el-form-item label="工艺描述" prop="crft_name">
            <el-input type="textarea" rows="1" v-model="crftForm.crft_name" maxlength="30" show-word-limit placeholder="请填写工艺名称"></el-input>
          </el-form-item>
        </el-col>
        <el-col :md="8">
          <el-form-item label="工艺类型" prop="crft_type">
            <el-select v-model="crftForm.crft_type" placeholder="请选择工艺类型" clearable @visible-change="getCrftType($event)">
              <el-option
                  v-for="item in crftTypeGroupOpt"
                  :key="item.id"
                  :label="item.param1"
                  :value="item.param1">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-divider></el-divider>
      <el-row class="vg_mt_16">
        <el-col>
          <inputUser :isCookie="false" :stffForm="stffForm" v-if="isShowInputer"></inputUser>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import {get,post} from "@api/request";
import {crftAPI} from "@api/modules/crft";
import inputUser from "@/views/component/inputUser";
import editHeader from "@/views/component/editHeader";
import options from "@/views/component/common/options";
import {optnAPI} from "@api/modules/optn";
export default {
  name: "CrftEditMain",
  components: {
    inputUser,
    editHeader
  },
  data() {
    return {
      crftForm: {
        status:null,
        crft_id :'',
        crft_no: '',
        crft_name: '',
        crft_type: '',
      },
      stffForm:{},
      key: 0,
      isShowInputer: false,
      isShow: true,
      btn:{},
      crftTypeGroupOpt:[],
      rules:{
        crft_no:[
          { required: true, trigger: 'blur', message: ' ' },
        ],
        crft_name:[
          { required: true, trigger: 'blur', message: ' ' },
        ],
        crft_type:[
          { required: true, trigger: 'change', message: ' ' },
        ],
      }
    }
  },
  created() {
    this.initData()
    this.crftTypeGroupOpt = options.crftOpts
  },
  methods: {
    //启用编辑
    openEdit(){
      this.isShow = false;
      this.$emit('isShow',this.isShow)
    },
    //撤销编辑
    closeEdit(){
      this.$confirm('是否撤销编辑?', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning'
      }).then(() => {
        this.isShow = true
        this.$emit('isShow',this.isShow)
        this.initData()
        this.$message({
          type: 'info',
          message: '已撤销编辑!'
        });
      })
    },
    initData(){
      if(this.$route.query.form_id){
        this.getCrftInfo();
      }
    },
    // 获取工艺类型
    getCrftType(flag){
      // if(flag === true && this.crftTypeGroupOpt.length === 0){
      //   this.crftTypeGroupOpt = options.crftOpts
      // }
      get(optnAPI.getAllContent,{perm_id : 10002})
          .then(res=>{
            if(res.data.code === 0) {
              this.crftTypeGroupOpt = res.data.data
            }
          })
    },
    //提交表单
    submit(formName){
      this.$confirm('确定提交？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.saveInfo()
          } else {
            console.log('error submit!');
            return false;
          }
        });
      })
    },
    // 保存
    saveInfo() {
      this.crftForm.crft_id = this.$route.query.form_id;
      post(crftAPI.editCrft,this.crftForm)
          .then(res => {
            if(res.data.code === 0){
              this.$message({
                type:'success',
                message:'保存成功'
              })
              this.isShow = true;
              this.$emit('isShow',this.isShow)
              this.initData()
            }else if(res.data.code === 7){
              this.$message({
                type:'error',
                message:'工艺编号重复'
              })
            }else {
              let mg = res.data.msg;
              let tp = 'error';
              this.$message({message: mg, type: tp});
              this.initData()
            }
          })
    },
    // 刷新按钮
    buttonRefresh(){
      this.initData()
    },
    //获取表单信息
    getCrftInfo() {
      this.crftForm.crft_id = this.$route.query.form_id;
      get(crftAPI.getCrftById, {crft_id:this.crftForm.crft_id})
          .then(res => {
            if (res.data.code === 0) {
              this.crftForm = res.data.data.form;
              this.isShowInputer = true
              this.stffForm.stff_name = this.crftForm.stff_name;
              this.stffForm.dept_name = this.crftForm.dept_name;
              this.stffForm.dept_team_name = this.crftForm.dept_team_name;
              this.stffForm.user_id = this.crftForm.user_id;
              this.stffForm.dept_id = this.crftForm.dept_id;
              this.stffForm.stff_id = this.crftForm.stff_id;
              this.btn = res.data.data.btn
            } else {
              let mg = res.data.msg;
              let tp = 'error';
              this.$message({message: mg, type: tp});
            }
          })
          .catch(res => {
            let mg = res.data.msg;
            let tp = 'error';
            this.$message({message: mg, type: tp});
          })
    }
  }
}
</script>

<style scoped>
.vd_edhea{
  position: relative;
}
.vd_export{
  position: absolute;
  top: 0;
  left: 65px;
}
</style>